<template>
	<CardGeneric class="border-secondary bg-secondary bg-opacity-10">
		<slot></slot>
	</CardGeneric>
</template>

<script setup></script>

<style lang="scss" scoped></style>
